import { DefaultHardStop } from "components/AppendixScreen/DefaultHardStop";
import { HOW_TO_CONTACT_US_TITLE } from "screens/Title.const";
import {
  CONTACT_US_HEADER,
  FINANCIAL_DIFFICULTY_TOP_TEXT,
} from "./HardStops.const";

export const FinDifficultyHardstop = () => {
  document.title = HOW_TO_CONTACT_US_TITLE;
  return (
    <DefaultHardStop header={CONTACT_US_HEADER}>
      {FINANCIAL_DIFFICULTY_TOP_TEXT}
    </DefaultHardStop>
  );
};
